import React, { useState, useEffect, createRef, useRef } from "react";
import { HomeScreenProps } from "../../navigation/home-stack/home-stack";
import { NumericInputNew } from "../../components";
import {
  StyleSheet,
  View,
  Image,
  Dimensions,
  SafeAreaView,
  ScrollView,
  Platform,
  Linking,
} from "react-native";
import random from "lodash/random";
import { translate } from "../../i18n";
import { CheckType, CheckImageType, CheckSubmitFields, useLocalMock } from "../../enums/check";
import { useNavigation } from "@react-navigation/native";
import { RootState } from "../../redux/reducers";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { checkInfoSchema } from "./utils/validation-schemas-payment";
import { DomusoApiService } from "../../api/DomusoApiService";
import { MockService } from "../../api/MockService";
import {
  updateCheckData,
  updateScanFrontResponse,
  updateScanBackResponse,
  updateError,
  setCheckRequestIsLoading,
  processFrontCheckScanImage,
  processBackCheckScanImage,
  cleanError,
  updateFrontPhoto,
  updateBackPhoto,
} from "../../redux/actions/actionCreators";
import { ocrAmount } from "../../utils/recognition";
import { isPersonalCheckAllowed } from "../../utils/payments";
import { useConfig } from "../../hooks/useConfig";
import { isDeviceVirtual } from "../../utils/virtualDevice";
import ssmConfig from "../../../config";
import { domusoResponsiveStyleHelper } from "./utils/domuso-responsive";
import { Grid, Container, Row, Column } from "ui-grid";
import { PaymentFlowMobileCheckPayProgressIndicator } from "../../components/new/payment-flow/payment-flow-mobile-check-pay-progress-indicator";
import automationTestingLocators from "./utils/automation-testing-locators.json";
import {
  typography,
  Text,
  theme,
  TextInput,
  OnScreenAlert,
  Button,
  ErrorWarningBottomSheet,
} from "ui-components";
import { UploadPhotoView } from "../../components/new/mobile-check-pay/upload-photo-view";
import { BottomNav } from "../../components/layout/bottom-nav";
import { Footer } from "../../components/new/footer/footer";
import { PaymentFlowPaymentMethodMobileCheckPaymentCameraWeb } from "./payment-flow-payment-method-mobile-check-payment-camera-web.web";
import Compressor from "compressorjs";
import { Camera } from "expo-camera";
import Auryc from "rn-auryc-sdk";
import { ScanFrontCheckResponseType } from "../../redux/store/check/type";

const DEFAULT_MAX_CHECK_AMOUNT = 5000;
const ROUTING_NUMBER_LENGTH = 9;
const ACCOUNT_NUMBER_MIN_LENGTH = 5;
const ACCOUNT_NUMBER_MAX_LENGTH = 20;
interface ErrorMsgObjectProps {
  title?: string;
  body?: string;
}
const PaymentFlowPaymentMethodMobileCheckPaymentProcessing = ({ route }: HomeScreenProps) => {
  const { params } = route;
  const config = useConfig();
  const {
    currentPropertyFeeProfile,
    currentPropertyProfile,
    propName,
    shouldDisableNonCertifiedMethods,
    checkTypeProp,
    amounts,
  } = params;
  const { non_certified_limit: nonCertifiedLimit } = currentPropertyFeeProfile;
  const [limit, setLimit] = useState(nonCertifiedLimit);
  const {
    allow_check_scan_certified: allowCertified,
    allow_check_scan_personal: allowPersonal,
    certified_end_day: certifiedEndDay,
    certified_start_day: certifiedStartDay,
  } = currentPropertyProfile;
  const styles = getStyles();
  const checkData = useSelector((state: RootState) => state.check.checkData);
  const frontResponse = useSelector((state: RootState) => state.check.frontResponse);
  const shouldProcessFrontCheckImage = useSelector(
    (state: RootState) => state.check.processFrontCheckScanImage
  );
  const shouldProcessBackCheckImage = useSelector(
    (state: RootState) => state.check.processBackCheckScanImage
  );
  const serverError = useSelector((state: RootState) => state.check.error);
  const isLoading = useSelector((state: RootState) => state.check.isLoading);
  const [amount, setAmount] = useState(checkData.amount);
  const [checkNumber, setCheckNumber] = useState(checkData.checkNumber);
  const [accountNumber, setAccountNumber] = useState(checkData.accountNumber);
  const [routingNumber, setRoutingNumber] = useState(checkData.routingNumber);
  const [checkType, setCheckType] = useState(checkData.checkType);
  const [photoFront, setPhotoFront] = useState(checkData.photoFront);
  const [photoFrontError, setPhotoFrontError] = useState(false);
  const [photoBack, setPhotoBack] = useState(checkData.photoBack);
  const [photoBackError, setPhotoBackError] = useState(false);
  const [hasPermission, setHasPermission] = useState(false);
  const [checkImageType, setCheckImageType] = useState<CheckImageType>(CheckImageType.FRONT);
  const errorPopupRef = useRef<any>();
  const warningPopupRef = useRef<any>();
  const warningCameraPermissionPopupRef = useRef<any>();
  const numberAmount = Number(amounts?.amount || 0);

  const [errorMsgObject, setErrorMsgObject] = useState<ErrorMsgObjectProps>({});
  const [warningMsgObject, setWarningMsgObject] = useState<ErrorMsgObjectProps>({});

  const frontElement = useRef(null);
  const backElement = useRef(null);

  const navigation = useNavigation();
  const dispatch = useDispatch();
  const cognitoUser = useSelector((state: RootState) => state.auth.cognitoUser);
  const logger = useSelector((state: RootState) => state.logger);
  const domusoApiService = Boolean(useLocalMock || isDeviceVirtual())
    ? new MockService(cognitoUser, dispatch, config.domusoApiService)
    : new DomusoApiService(cognitoUser, dispatch);
  const inputAccessoryViewID = "inputAccessoryViewID1";
  const ref = [createRef(), createRef(), createRef(), createRef()];
  const [currentInputIndex, setCurrentInputIndex] = useState(0);
  const allowPersonalCheck =
    !shouldDisableNonCertifiedMethods &&
    isPersonalCheckAllowed({ certifiedStartDay, certifiedEndDay });

  let defaultValues: any = {
    photoFront: checkData.photoFront,
    photoBack: checkData.photoBack,
    checkType: checkData.checkType,
    amount: checkData.amount,
    routingNumber: checkData.routingNumber,
    accountNumber: checkData.accountNumber,
    checkNumber: checkData.checkNumber,
  };

  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    clearErrors,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(checkInfoSchema(limit ? limit / 100 : DEFAULT_MAX_CHECK_AMOUNT)),
    defaultValues,
  });

  const getDisabled = () => {
    return (
      !amount ||
      !checkType ||
      !photoFront ||
      !photoBack ||
      shouldProcessBackCheckImage ||
      shouldProcessFrontCheckImage ||
      isLoading
    );
  };

  const scanFrontCheckAndValidatePayment = async (shouldProcessFrontCheckImage: boolean) => {
    if (shouldProcessFrontCheckImage) {
      try {
        dispatch(cleanError());
        dispatch(setCheckRequestIsLoading(true));
        setPhotoFrontError(false);
        const props = { ...getValues() };
        //Request to process photos
        const scanFrontCheckResponse = await domusoApiService.scanFrontCheck(props.photoFront);
        const photoUri = `data:image/jpeg;base64,${scanFrontCheckResponse?.processed_image}`;
        dispatch(updateScanFrontResponse(scanFrontCheckResponse));

        //beeceptor will always return same check number which will endup in duplicate check detected.
        //Will randomize the cheknumber onlye when mock is enabled, if duplicate check needs to be tested
        //cheknumber can be set in the UI to existing one.
        const checkNumberValue =
          ssmConfig.mockScanData === "true"
            ? random(100000, 9999999999).toString()
            : scanFrontCheckResponse.check_number;

        const routingNumberValue = scanFrontCheckResponse.routing_number;
        const accountNumberValue = scanFrontCheckResponse.account_number;

        updateCheckNumber(checkNumberValue);
        updateRoutingNumber(routingNumberValue);
        updateAccountNumber(accountNumberValue);

        if (routingNumberValue && routingNumberValue.length !== ROUTING_NUMBER_LENGTH) {
          logger.info(
            `Routing number error while processing front check image. routing number length: ${routingNumberValue?.length}`
          );
          updateServerError(
            translate("paymentFlow.paymentMethodMobileCheckPay.processing.imageErrorTitle"),
            translate("paymentFlow.paymentMethodMobileCheckPay.processing.imageErrorMessage")
          );
          return;
        }

        if (
          accountNumberValue &&
          (accountNumberValue.length < ACCOUNT_NUMBER_MIN_LENGTH ||
            accountNumberValue.length > ACCOUNT_NUMBER_MAX_LENGTH)
        ) {
          logger.info(
            `Account number error while processing front check image. account number length: ${accountNumberValue?.length}`
          );
          updateServerError(
            translate("paymentFlow.paymentMethodMobileCheckPay.processing.imageErrorTitle"),
            translate("paymentFlow.paymentMethodMobileCheckPay.processing.imageErrorMessage")
          );
          return;
        }

        // this can happen if user scans a CERTIFIED check and misclassify it as personal
        // or simply because the image processing service was unable to parse one of these fields
        if (
          (props.checkType == CheckType.PERSONAL && !checkNumberValue) ||
          !accountNumberValue ||
          !routingNumberValue
        ) {
          logger.info(
            `Check type error while processing front check image. Type: ${props.checkType} checkNumber: ${checkNumberValue}`
          );
          updateServerError(
            translate("paymentFlow.paymentMethodMobileCheckPay.processing.imageErrorTitle"),
            translate("paymentFlow.paymentMethodMobileCheckPay.processing.imageErrorMessage")
          );
          return;
        }

        const findDuplicateResponse = await domusoApiService.findDuplicates(
          checkNumberValue,
          props.checkType,
          accountNumberValue,
          routingNumberValue
        );

        if (findDuplicateResponse.count > 0) {
          const duplicateOrderId = findDuplicateResponse.orderId;
          setPhotoFrontError(true);
          updateServerError(
            translate(
              "paymentFlow.paymentMethodMobileCheckPay.processing.duplicateCheckErrorTitle"
            ) || "",
            translate(
              "paymentFlow.paymentMethodMobileCheckPay.processing.duplicateCheckConfirmationMessage"
            ) + duplicateOrderId || ""
          );
          return;
        }

        updateCheckWarning(scanFrontCheckResponse);

        dispatch(setCheckRequestIsLoading(false));
        dispatch(processFrontCheckScanImage(false));
        dispatch(updateFrontPhoto(photoUri));
      } catch (error) {
        setPhotoFrontError(true);
        logger.info("Error while processing front check image");
        logger.error(error);
        updateServerError(
          translate("paymentFlow.paymentMethodMobileCheckPay.processing.frontImageErrorTitle"),
          translate("paymentFlow.paymentMethodMobileCheckPay.processing.frontImageErrorMessage")
        );
      }
    }
  };

  const scanBackCheck = async (shouldProcessBackCheckImage: boolean) => {
    if (shouldProcessBackCheckImage) {
      try {
        dispatch(cleanError());
        dispatch(setCheckRequestIsLoading(true));
        setPhotoBackError(false);

        const scanBackCheckResponse = await domusoApiService.scanBackCheck({
          uri: checkData.photoBack,
          tempId: frontResponse ? frontResponse.temp_id : "",
          accountNumber,
          routingNumber,
          propertyName: propName,
        });
        const photoUri = `data:image/jpeg;base64,${scanBackCheckResponse?.processed_image}`;

        dispatch(setCheckRequestIsLoading(false));
        dispatch(processBackCheckScanImage(false));
        dispatch(updateBackPhoto(photoUri));
        dispatch(updateScanBackResponse(scanBackCheckResponse));
      } catch (error) {
        setPhotoBackError(true);
        logger.info("Error while processing back check image");
        logger.error(error);
        updateServerError(
          translate("paymentFlow.paymentMethodMobileCheckPay.processing.backImageErrorTitle"),
          translate("paymentFlow.paymentMethodMobileCheckPay.processing.backImageErrorMessage")
        );
      }
    }
  };

  const navigateToConfirmDetails = async () => {
    dispatch(setCheckRequestIsLoading(true));
    const props = { ...getValues() };
    props.checkNumber = checkNumber;
    props.routingNumber = routingNumber;
    props.accountNumber = accountNumber;
    props.photoFront = photoFront;
    props.photoBack = photoBack;
    props.amount = amount;
    props.checkType = checkType;

    //Is possible that user updated the check data manually, will check for dup again before proceeding.
    const findDuplicateResponse = await domusoApiService.findDuplicates(
      props.checkNumber,
      props.checkType,
      props.accountNumber,
      props.routingNumber
    );

    dispatch(setCheckRequestIsLoading(false));
    if (findDuplicateResponse.count > 0) {
      const duplicateOrderId = findDuplicateResponse.orderId;
      setPhotoFrontError(true);
      updateServerError(
        translate("paymentFlow.paymentMethodMobileCheckPay.processing.duplicateCheckErrorTitle") ||
          "",
        translate(
          "paymentFlow.paymentMethodMobileCheckPay.processing.duplicateCheckConfirmationMessage"
        ) + duplicateOrderId || ""
      );
      return;
    }

    //Set state with updated values from form before navigation.
    dispatch(updateCheckData(props));
    navigation.navigate("PaymentFlowPaymentMethodMobileCheckPaymentSummary", { ...params });
  };

  const navigateToCamera = async (checkImageType: CheckImageType) => {
    //Camera is not suported on android/ios emulator
    //https://docs.expo.dev/versions/latest/sdk/camera/
    if (isDeviceVirtual()) {
      switch (checkImageType) {
        case CheckImageType.FRONT:
          dispatch(processFrontCheckScanImage(true));
          break;
        case CheckImageType.BACK:
          dispatch(processBackCheckScanImage(true));
          break;
      }
    } else {
      if (Platform.OS === "web") {
        setCheckImageType(checkImageType);
        const elementToClick = checkImageType === CheckImageType.FRONT ? frontElement : backElement;
        elementToClick?.current?.click();
      } else {
        //Prompt user for permissions android/ios
        const { status } = await Camera.requestCameraPermissionsAsync();
        //If the camera access is denied bottom sheet will be displayed to let user know permission is required.
        if (status !== "granted") {
          warningCameraPermissionPopupRef?.current?.open();
        } else {
          navigation.navigate("PaymentFlowPaymentMethodMobileCheckPaymentCamera", {
            checkImageType: checkImageType,
            errorWarningBottomSheet: warningCameraPermissionPopupRef,
          });
        }
      }
    }
  };

  const updateServerError = (errorTitle: string | null, errorMessage: string | null) => {
    const error = { title: errorTitle, message: errorMessage };
    dispatch(setCheckRequestIsLoading(false));
    dispatch(processFrontCheckScanImage(false));
    dispatch(processBackCheckScanImage(false));
    dispatch(updateError(error));
  };

  const updateCheckWarning = (scanFrontCheckResponse: ScanFrontCheckResponseType | null) => {
    if (scanFrontCheckResponse) {
      const props = { ...getValues() };
      let warningTitle, warningBody;
      const usabilityTest = scanFrontCheckResponse.image_analysis.usability_test;
      if (ocrAmount(scanFrontCheckResponse.recognition_result) != props.amount) {
        warningTitle = translate(
          "paymentFlow.paymentMethodMobileCheckPay.processing.warningInvalidCheckAmountTitle"
        );
        warningBody = translate(
          "paymentFlow.paymentMethodMobileCheckPay.processing.warningInvalidCheckAmountMessage"
        );
      } else if (!usabilityTest.signature_passed) {
        warningTitle = translate(
          "paymentFlow.paymentMethodMobileCheckPay.processing.warningInvalidSignatureCheckTestTitle"
        );
        warningBody = translate(
          "paymentFlow.paymentMethodMobileCheckPay.processing.warningInvalidSignatureCheckTestMessage"
        );
      } else if (!usabilityTest.date_passed) {
        warningTitle = translate(
          "paymentFlow.paymentMethodMobileCheckPay.processing.warningInvalidDateCheckTestTitle"
        );
        warningBody = translate(
          "paymentFlow.paymentMethodMobileCheckPay.processing.warningInvalidDateCheckTestMessage"
        );
      } else if (!usabilityTest.courtesy_amount_passed) {
        warningTitle = translate(
          "paymentFlow.paymentMethodMobileCheckPay.processing.warningInvalidAmountCheckTestTitle"
        );
        warningBody = translate(
          "paymentFlow.paymentMethodMobileCheckPay.processing.warningInvalidAmountCheckTestMessage"
        );
      }

      if (warningTitle && warningBody) {
        setWarningMsgObject({
          title: warningTitle as string,
          body: warningBody as string,
        });
        warningPopupRef?.current?.open();
      }
    }
  };

  const selectCheckType = (type: CheckType) => {
    setCheckType(type);
    setValue(CheckSubmitFields.CHECK_TYPE, type);
    clearErrors(CheckSubmitFields.CHECK_TYPE);
  };

  const selectAmount = (amount: number) => {
    setAmount(amount);
    setValue(CheckSubmitFields.AMOUNT, amount);
    clearErrors(CheckSubmitFields.AMOUNT);
  };

  const updateRoutingNumber = (routingNumber: string) => {
    setRoutingNumber(routingNumber);
    setValue(CheckSubmitFields.ROUTING_NUMBER, routingNumber);
    clearErrors(CheckSubmitFields.ROUTING_NUMBER);
  };

  const updateCheckNumber = (checkNumber: string) => {
    setCheckNumber(checkNumber);
    setValue(CheckSubmitFields.CHECK_NUMBER, checkNumber);
    clearErrors(CheckSubmitFields.CHECK_NUMBER);
  };

  const updateAccountNumber = (accountNumber: string) => {
    setAccountNumber(accountNumber);
    setValue(CheckSubmitFields.ACCOUNT_NUMBER, accountNumber);
    clearErrors(CheckSubmitFields.ACCOUNT_NUMBER);
  };

  const errorTextBody = (errorTitle: string, errorMessage: string) => {
    const isDuplicateCheckError =
      translate("paymentFlow.paymentMethodMobileCheckPay.processing.duplicateCheckErrorTitle") ===
      errorTitle;
    //   <TextUiComponent
    //   {...automationTestingLocators.paymentFlowPaymentMethodMobileCheckPayProcessing
    //     .errorTextDuplicateCheck}>
    //   {text} <TextUiComponent style={{ fontFamily: "Lato_700Bold" }}>{date}</TextUiComponent>
    // </TextUiComponent>
    return isDuplicateCheckError ? errorTextBodyForDuplicateCheck(errorMessage) : errorMessage;
  };
  const errorTextBodyForDuplicateCheck = (errorMessage: string) => {
    const split = errorMessage.split(" ");
    const date = split.pop();
    const text = split.join(" ");
    let message = text + " " + date;
    return message;
  };

  const validateCheckNumberFromImage = (showWarningPopup?: boolean) => {
    const props = { ...getValues() };
    if (photoFront && frontResponse && showCheckInputFields()) {
      const checkNumberValue = frontResponse.check_number;
      if (ssmConfig.mockScanData !== "true" && checkNumberValue != props.checkNumber) {
        if (showWarningPopup) {
          setWarningMsgObject({
            title: translate(
              "paymentFlow.paymentMethodMobileCheckPay.processing.warningInvalidCheckNumberTitle"
            ) as string,
            body: translate(
              "paymentFlow.paymentMethodMobileCheckPay.processing.warningInvalidCheckNumberMessage"
            ) as string,
          });
          warningPopupRef?.current?.open();
        }
      }
    }
  };
  useEffect(() => {
    register(CheckSubmitFields.PHOTO_FRONT);
    register(CheckSubmitFields.PHOTO_BACK);
    register(CheckSubmitFields.CHECK_TYPE);
    register(CheckSubmitFields.AMOUNT);
    register(CheckSubmitFields.ROUTING_NUMBER);
    register(CheckSubmitFields.CHECK_NUMBER);
    register(CheckSubmitFields.ACCOUNT_NUMBER);
  }, [register]);

  useEffect(() => {
    setPhotoFront(checkData.photoFront);
    setValue(CheckSubmitFields.PHOTO_FRONT, checkData.photoFront);
    clearErrors(CheckSubmitFields.PHOTO_FRONT);

    setPhotoBack(checkData.photoBack);
    setValue(CheckSubmitFields.PHOTO_BACK, checkData.photoBack);
    clearErrors(CheckSubmitFields.PHOTO_BACK);
  }, [checkData]);

  useEffect(() => {
    scanFrontCheckAndValidatePayment(shouldProcessFrontCheckImage);
  }, [shouldProcessFrontCheckImage]);

  useEffect(() => {
    selectAmount(numberAmount / 100 || 0);
  }, []);

  useEffect(() => {
    scanBackCheck(shouldProcessBackCheckImage);
  }, [shouldProcessBackCheckImage]);

  useEffect(() => {
    let title =
      checkTypeProp == CheckType.PERSONAL
        ? (translate("paymentFlow.paymentMethodMobilePersonalCheck.workflowTitle") as string)
        : (translate("paymentFlow.paymentMethodMobileMoneyOrder.workflowTitle") as string);
    navigation.setParams({ headerTitle: title });
    if (checkTypeProp == CheckType.PERSONAL && allowPersonalCheck) {
      if (amount) {
        selectCheckType(CheckType.PERSONAL);
      }
    }
    if (checkTypeProp == CheckType.CERTIFIED && amount) {
      selectCheckType(CheckType.CERTIFIED);
    }
  }, [amount, allowPersonalCheck]);

  const renderRequiredMessage = () => {
    if (!allowPersonalCheck) {
      return (
        <View style={{ flex: 1 }}>
          <View style={{ margin: 8 }} />
          <OnScreenAlert
            alertType="caution"
            titleStye={{ marginTop: -1.5, color: theme.colors.text3, fontWeight: "400" }}
            title={
              translate(
                "paymentFlow.paymentMethodMobileCheckPay.processing.aCertifiedCheckIsRequired"
              ) as string
            }
            {...automationTestingLocators.paymentFlowPaymentMethodMobileCheckPayProcessing
              .aCertifiedCheckIsRequired}
          />
        </View>
      );
    }
    return null;
  };

  const disableBackCheckBox = () => {
    if (
      !photoFront ||
      !checkType ||
      !amount ||
      photoFrontError ||
      shouldProcessBackCheckImage ||
      shouldProcessFrontCheckImage
    ) {
      return true;
    }

    return false;
  };

  const disableFrontCheckBox = () => {
    if (!checkType || !amount || shouldProcessFrontCheckImage) {
      return true;
    }

    return false;
  };

  const showCheckInputFields = () => {
    if (
      photoFront &&
      photoBack &&
      checkType &&
      !serverError &&
      !shouldProcessBackCheckImage &&
      !shouldProcessFrontCheckImage
    ) {
      return true;
    }

    return false;
  };
  const logCameraPermissions = async () => {
    //permissions.query compatibility: https://developer.mozilla.org/en-US/docs/Web/API/Permissions/query#browser_compatibility
    navigator.mediaDevices
      .getUserMedia({ video: { facingMode: "environment" } })
      .then((stream) => {
        // console.log(stream);
        setHasPermission(true);
      })
      .catch((err) => {
        setHasPermission(false);
        console.error(
          `Unable to prompt or access camera permissions message:: ${err} stack: ${err.stack}`
        );
      });
  };

  useEffect(() => {
    if (Platform.OS == "web") {
      logCameraPermissions();
    }
  }, []);

  function readAsDataURL(inputFile: Blob) {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
      reader.onerror = () => {
        reader.abort();
        reject(new DOMException("Problem parsing input file."));
      };

      reader.onload = () => {
        resolve(reader.result);
      };
      reader.readAsDataURL(inputFile);
    });
  }

  function handleImageCapture(side: any) {
    return async (e: { target: { files: [any] } }) => {
      const [file] = e.target.files;
      if (file) {
        if (file.type !== "image/jpeg") {
          logger.log(`unsupported file type. type: ${file.type}`);
          return;
        }

        const compressedImage = await compress(file);
        const compressedImageDataURL = await readAsDataURL(compressedImage);

        const fileObject = {
          fileName: ssmConfig?.mockScanData === "true" ? `${side}.jpg` : file.name,
          type: "image/jpeg",
          fileBody: compressedImageDataURL,
        };

        // console.log(side, fileObject);
        switch (side) {
          case CheckImageType.FRONT:
            dispatch(updateFrontPhoto(fileObject.fileBody));
            dispatch(processFrontCheckScanImage(true));
            break;
          case CheckImageType.BACK:
            dispatch(updateBackPhoto(fileObject.fileBody));
            dispatch(processBackCheckScanImage(true));
            break;
        }
      }
    };
  }

  const compressionOptions = {
    quality: 0.6,
    width: 1920,
    height: 1920,
    checkOrientation: false,
  };

  function compress(file: any) {
    return new Promise((resolve, reject) => {
      new Compressor(file, {
        ...compressionOptions,
        success(result) {
          resolve(result);
        },
        error(err) {
          logger.log("failure to compress. Details: " + err);
          reject(err);
        },
      });
    });
  }

  useEffect(() => {
    if (serverError) {
      setErrorMsgObject({
        title: serverError?.title,
        body: errorTextBody(serverError?.title, serverError?.message),
      });
      errorPopupRef?.current?.open();
    }
  }, [serverError]);

  return (
    <SafeAreaView style={styles.container}>
      <ScrollView
        showsVerticalScrollIndicator={false}
        style={styles.scrollView}
        contentContainerStyle={styles.scrollableArea}>
        <View style={{ flex: 1 }}>
          <Grid>
            <Container>
              <View style={{ margin: 8 }} />
              <Row>
                <Container>
                  <PaymentFlowMobileCheckPayProgressIndicator currentPosition={0} />
                </Container>
              </Row>
              <View style={{ margin: 8 }} />

              <Row>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                <Column
                  span={{ xs: 12, sm: 8, md: 8, lg: 8 }}
                  style={[styles.inputRow, styles.header]}>
                  <View style={styles.inputRowInner}>
                    <View style={{ flex: 1 }}>
                      <NumericInputNew
                        style={{ width: "100%" }}
                        labelStyle={{ fontFamily: "Lato_700Bold" }}
                        label={
                          translate(
                            "paymentFlow.paymentMethodMobileCheckPay.processing.checkAmount"
                          ) as string
                        }
                        value={amount}
                        disabled={false}
                        onChangeText={(val) => {
                          selectAmount(val ? val : 0);
                        }}
                        inputAccessoryViewID={inputAccessoryViewID}
                        ref={ref[0] as any}
                        onFocus={() => setCurrentInputIndex(0)}
                        name="checkImage-amountInput"
                        errors={errors?.["amount"]}
                        placeholder={"$0.00"}
                        {...automationTestingLocators
                          .paymentFlowPaymentMethodMobileCheckPayProcessing.checkAmountInput}
                      />
                    </View>
                  </View>
                </Column>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
              </Row>

              <Row>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                <Column span={{ xs: 12, sm: 8, md: 8, lg: 8 }} style={styles.inputRow}>
                  <View style={styles.inputRowInner}>
                    <View style={{ flex: 1 }}>
                      <View style={{ margin: 4 }} />
                      <View style={{ flexDirection: "row" }}>
                        <View
                          style={{ flex: 1, marginRight: 8, width: "100%" }}
                          onLayout={(event) => {
                            let { width, height } = event.nativeEvent.layout;
                          }}>
                          <UploadPhotoView
                            onPress={() => navigateToCamera(CheckImageType.FRONT)}
                            title={
                              translate(
                                "paymentFlow.paymentMethodMobileCheckPay.processing.frontLabel"
                              ) as string
                            }
                            photo={photoFront && !photoFrontError ? photoFront : ""}
                            isProcessing={shouldProcessFrontCheckImage}
                            disabled={disableFrontCheckBox()}
                            {...automationTestingLocators
                              .paymentFlowPaymentMethodMobileCheckPayProcessing.frontTakePhotoCard}
                          />
                        </View>
                        <View style={{ flex: 1, marginLeft: 8, width: "100%" }}>
                          <UploadPhotoView
                            onPress={() => navigateToCamera(CheckImageType.BACK)}
                            title={
                              translate(
                                "paymentFlow.paymentMethodMobileCheckPay.processing.backLabel"
                              ) as string
                            }
                            photo={photoBack && !photoBackError ? photoBack : ""}
                            isProcessing={shouldProcessBackCheckImage}
                            disabled={disableBackCheckBox()}
                            {...automationTestingLocators
                              .paymentFlowPaymentMethodMobileCheckPayProcessing.backTakePhotoCard}
                          />
                        </View>
                      </View>
                    </View>
                  </View>
                </Column>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
              </Row>
              <Row>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                <Column span={{ xs: 12, sm: 8, md: 8, lg: 8 }} style={styles.inputRow}>
                  <View style={styles.inputRowInner}>{renderRequiredMessage()}</View>
                </Column>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
              </Row>

              {showCheckInputFields() && (
                <View>
                  <Row>
                    <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                    <Column span={{ xs: 12, sm: 8, md: 8, lg: 8 }} style={styles.inputRow}>
                      <View style={styles.inputRowInner}>
                        <View
                          style={{ flex: 1, marginTop: 8 }}
                          ref={(x) => Auryc.unMarkViewAsSensitiveInformation(x)}
                          accessible={true}>
                          <TextInput
                            onChangeText={(val) => updateCheckNumber(val)}
                            value={checkNumber?.trim()}
                            ref={ref[1] as any}
                            error={errors.checkNumber}
                            placeholder={
                              translate(
                                "paymentFlow.paymentMethodMobileCheckPay.processing.checkNumber"
                              ) as string
                            }
                            labelStyle={{ fontFamily: "Lato_700Bold" }}
                            label={
                              translate(
                                "paymentFlow.paymentMethodMobileCheckPay.processing.checkNumber"
                              ) as string
                            }
                            mode="outlined"
                            keyboardType={"number-pad"}
                            returnKeyType="next"
                            inputAccessoryViewID={inputAccessoryViewID}
                            onFocus={() => setCurrentInputIndex(1)}
                            onSubmitEditing={() => (ref[2].current as any).focus()}
                            onBlur={() => {
                              validateCheckNumberFromImage(true);
                            }}
                            {...automationTestingLocators
                              .paymentFlowPaymentMethodMobileCheckPayProcessing.checkNumberInput}
                            dataSet={{ heapRedactText: "" }}
                          />
                        </View>
                      </View>
                    </Column>
                    <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                  </Row>
                  <Row>
                    <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                    <Column span={{ xs: 12, sm: 8, md: 8, lg: 8 }} style={styles.inputRow}>
                      <View style={styles.inputRowInner}>
                        <View
                          style={{ flex: 1, marginTop: 8 }}
                          ref={(x) => Auryc.unMarkViewAsSensitiveInformation(x)}
                          accessible={true}>
                          <TextInput
                            onChangeText={(val) => updateRoutingNumber(val)}
                            value={routingNumber?.trim()}
                            ref={ref[2] as any}
                            error={errors.routingNumber}
                            placeholder="xxxxxxxxx"
                            labelStyle={{ fontFamily: "Lato_700Bold" }}
                            label={
                              translate(
                                "paymentFlow.paymentMethodMobileCheckPay.processing.routingNumber"
                              ) as string
                            }
                            mode="outlined"
                            keyboardType={"number-pad"}
                            maxLength={9}
                            inputAccessoryViewID={inputAccessoryViewID}
                            onFocus={() => setCurrentInputIndex(2)}
                            onSubmitEditing={() => (ref[3].current as any).focus()}
                            {...automationTestingLocators
                              .paymentFlowPaymentMethodMobileCheckPayProcessing.routingNumberInput}
                            dataSet={{ heapRedactText: "" }}
                          />
                        </View>
                      </View>
                    </Column>
                    <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                  </Row>
                  <Row>
                    <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                    <Column span={{ xs: 12, sm: 8, md: 8, lg: 8 }} style={styles.inputRow}>
                      <View style={styles.inputRowInner}>
                        <View
                          style={{ flex: 1, marginTop: 8 }}
                          ref={(x) => Auryc.markViewAsSensitiveInformation(x)}
                          accessible={true}>
                          <TextInput
                            onChangeText={(val) => updateAccountNumber(val)}
                            value={accountNumber?.trim()}
                            ref={ref[3] as any}
                            error={errors.accountNumber}
                            placeholder={
                              translate(
                                "paymentFlow.paymentMethodMobileCheckPay.processing.accountNumber"
                              ) as string
                            }
                            labelStyle={{ fontFamily: "Lato_700Bold" }}
                            label={
                              translate(
                                "paymentFlow.paymentMethodMobileCheckPay.processing.accountNumber"
                              ) as string
                            }
                            mode="outlined"
                            keyboardType={"number-pad"}
                            inputAccessoryViewID={inputAccessoryViewID}
                            onFocus={() => setCurrentInputIndex(2)}
                            // onSubmitEditing={onSubmitEditing}

                            {...automationTestingLocators
                              .paymentFlowPaymentMethodMobileCheckPayProcessing.accountNumberInput}
                            dataSet={{ heapRedactText: "" }}
                          />
                        </View>
                      </View>
                    </Column>
                    <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                  </Row>
                </View>
              )}

              <Row>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
                <Column span={{ xs: 12, sm: 8, md: 8, lg: 8 }} style={styles.inputRow}>
                  <View style={styles.inputRowInner}>
                    <View style={{ flex: 1 }}>
                      <View style={{ margin: 10 }} />

                      <OnScreenAlert
                        alertType="caution"
                        titleStye={{
                          marginTop: -1,
                          color: theme.colors.text3,
                          fontWeight: "400",
                        }}
                        title={
                          translate(
                            "paymentFlow.paymentMethodMobileCheckPay.processing.submitOneCheckPerTransaction"
                          ) as string
                        }
                        {...automationTestingLocators
                          .paymentFlowPaymentMethodMobileCheckPayProcessing
                          .submitOneCheckPerTransaction}
                      />

                      {serverError && (
                        <>
                          <View style={{ margin: 10 }} />
                          {photoFrontError && (
                            <Image
                              source={{ uri: photoFront }}
                              style={styles.check}
                              {...automationTestingLocators
                                .paymentFlowPaymentMethodMobileCheckPayProcessing
                                .errorFrontCheckImage}
                            />
                          )}
                          {photoBackError && (
                            <>
                              <View style={{ margin: 8 }} />

                              <Image
                                source={{ uri: photoBack }}
                                style={styles.check}
                                {...automationTestingLocators
                                  .paymentFlowPaymentMethodMobileCheckPayProcessing
                                  .errorBackCheckImage}
                              />
                            </>
                          )}
                        </>
                      )}
                    </View>
                  </View>
                </Column>
                <Column span={{ xs: false, sm: 2, md: 2, lg: 2 }} />
              </Row>
            </Container>
          </Grid>
        </View>
      </ScrollView>
      <BottomNav backgroundColor={theme.colors.white}>
        <Row>
          <Column span={{ xs: false, sm: 3, md: 3, lg: 3 }} />
          <Column span={{ xs: 12, sm: 6, md: 6, lg: 6 }}>
            {!serverError && (
              <Button
                text={
                  translate("paymentFlow.paymentMethodMobileCheckPay.processing.next") as string
                }
                mode="contained"
                disabled={getDisabled()}
                loading={isLoading}
                onPress={handleSubmit(navigateToConfirmDetails)}
                {...automationTestingLocators.paymentFlowPaymentMethodMobileCheckPayProcessing
                  .nextButton}
              />
            )}
          </Column>
          <Column span={{ xs: false, sm: 3, md: 3, lg: 3 }} />
        </Row>
      </BottomNav>
      {Platform.OS == "web" && (
        <>
          <PaymentFlowPaymentMethodMobileCheckPaymentCameraWeb
            type={checkImageType}
            refEl={frontElement}
            handleCapture={handleImageCapture}
          />
          <PaymentFlowPaymentMethodMobileCheckPaymentCameraWeb
            type={checkImageType}
            refEl={backElement}
            handleCapture={handleImageCapture}
          />
        </>
      )}

      <Footer />
      <ErrorWarningBottomSheet
        ref={errorPopupRef}
        title={errorMsgObject?.title}
        body={errorMsgObject?.body}
        height={165}
        alertType={"error"}
        showButtons={false}
        {...automationTestingLocators.paymentFlowPaymentMethodMobileCheckPayProcessing.errorAlert}
      />
      <ErrorWarningBottomSheet
        ref={warningPopupRef}
        title={warningMsgObject?.title}
        body={warningMsgObject?.body}
        height={140}
        alertType={"warning"}
        showButtons={false}
        showLeftButton={false}
        showRightButton={false}
        {...automationTestingLocators.paymentFlowPaymentMethodMobileCheckPayProcessing.warningAlert}
      />
      <ErrorWarningBottomSheet
        ref={warningCameraPermissionPopupRef}
        title={translate(
          "paymentFlow.paymentMethodMobileCheckPay.processing.warningUnableToAccessCameraTitle"
        )}
        body={
          Platform.OS === "ios"
            ? translate(
                "paymentFlow.paymentMethodMobileCheckPay.processing.warningUnableToAccessCameraMessageIOS"
              )
            : translate(
                "paymentFlow.paymentMethodMobileCheckPay.processing.warningUnableToAccessCameraMessageAndroid"
              )
        }
        height={230}
        alertType={"warning"}
        leftButtonText={translate(
          "paymentFlow.paymentMethodMobileCheckPay.processing.warningUnableToAccessCameraLeftButtonText"
        )}
        rightButtonText={translate(
          "paymentFlow.paymentMethodMobileCheckPay.processing.warningUnableToAccessCameraRightButtonText"
        )}
        leftButtonType={"secondary"}
        leftButtonStyle={{ marginTop: 20 }}
        rightButtonStyle={{ marginTop: 20 }}
        onPressLeftButton={() => {
          warningCameraPermissionPopupRef?.current?.close();
        }}
        onPressRightButton={() => {
          warningCameraPermissionPopupRef?.current?.close();
          Linking.openSettings();
        }}
        {...automationTestingLocators.paymentFlowPaymentMethodMobileCheckPayProcessing.warningAlert}
      />
    </SafeAreaView>
  );
};

const getStyles = () => {
  const { width } = Dimensions.get("window");
  return StyleSheet.create({
    container: {
      flex: 1,
      ...domusoResponsiveStyleHelper({
        webPhone: {
          backgroundColor: theme.colors.white,
        },
        webTablet: {
          backgroundColor: "#FAFAFA",
        },
        webDesktop: {
          backgroundColor: "#FAFAFA",
        },
        iosPhone: {
          backgroundColor: theme.colors.white,
        },
        iosTablet: {
          backgroundColor: "#FAFAFA",
        },
        androidPhone: {
          backgroundColor: theme.colors.white,
        },
        androidTablet: {
          backgroundColor: "#FAFAFA",
        },
      }),
    },
    scrollView: { flexGrow: 0 },
    scrollableArea: {
      ...domusoResponsiveStyleHelper({
        webPhone: { backgroundColor: theme.colors.white, paddingBottom: 10 },
        webTablet: { backgroundColor: "#FAFAFA", paddingBottom: 10, marginTop: 15 },
        webDesktop: { backgroundColor: "#FAFAFA", paddingBottom: 10, marginTop: 15 },
        iosPhone: { backgroundColor: theme.colors.white, paddingBottom: 250 },
        iosTablet: { backgroundColor: "#FAFAFA", paddingBottom: 10, marginTop: 15 },
        androidPhone: { backgroundColor: theme.colors.white, paddingBottom: 250 },
        androidTablet: { backgroundColor: "#FAFAFA", paddingBottom: 10, marginTop: 15 },
      }),
    },
    inputRow: {
      ...domusoResponsiveStyleHelper({
        webPhone: {},
        webTablet: {
          paddingLeft: 30,
          paddingRight: 30,
          backgroundColor: "white",
          borderLeftWidth: 1,
          borderLeftColor: "rgba(102, 102, 102, 0.1)",
          borderRightWidth: 1,
          borderRightColor: "rgba(102, 102, 102, 0.1)",
        },
        webDesktop: {
          paddingLeft: 40,
          paddingRight: 40,
          backgroundColor: "white",
          borderLeftWidth: 1,
          borderLeftColor: "rgba(102, 102, 102, 0.1)",
          borderRightWidth: 1,
          borderRightColor: "rgba(102, 102, 102, 0.1)",
        },
        iosPhone: {},
        iosTablet: {
          paddingLeft: 30,
          paddingRight: 30,
          backgroundColor: "white",
          borderLeftWidth: 1,
          borderLeftColor: "rgba(102, 102, 102, 0.1)",
          borderRightWidth: 1,
          borderRightColor: "rgba(102, 102, 102, 0.1)",
        },
        androidPhone: {},
        androidTablet: {
          paddingLeft: 30,
          paddingRight: 30,
          backgroundColor: "white",
          borderLeftWidth: 1,
          borderLeftColor: "rgba(102, 102, 102, 0.1)",
          borderRightWidth: 1,
          borderRightColor: "rgba(102, 102, 102, 0.1)",
        },
      }),
    },
    inputRowInner: {
      flex: 1,
      flexDirection: "row",
      ...domusoResponsiveStyleHelper({
        webPhone: {},
        webTablet: {
          paddingLeft: 10,
          paddingRight: 10,
        },
        webDesktop: {
          paddingLeft: 30,
          paddingRight: 30,
        },
        iosPhone: {},
        iosTablet: {
          paddingLeft: 10,
          paddingRight: 10,
        },
        androidPhone: {},
        androidTablet: {
          paddingLeft: 10,
          paddingRight: 10,
        },
      }),
    },
    header: {
      ...domusoResponsiveStyleHelper({
        webPhone: { paddingVertical: 3 },
        webTablet: {
          borderTopRightRadius: 10,
          borderTopLeftRadius: 10,

          borderLeftWidth: 1,
          borderLeftColor: "rgba(102, 102, 102, 0.1)",
          borderTopWidth: 1,
          borderTopColor: "rgba(102, 102, 102, 0.1)",
          borderRightWidth: 1,
          borderRightColor: "rgba(102, 102, 102, 0.1)",

          background: "#FFFFFF",

          paddingTop: 30,
          paddingLeft: 40,
          paddingRight: 40,
          backgroundColor: "white",
        },
        webDesktop: {
          borderTopRightRadius: 10,
          borderTopLeftRadius: 10,

          borderLeftWidth: 1,
          borderLeftColor: "rgba(102, 102, 102, 0.1)",
          borderTopWidth: 1,
          borderTopColor: "rgba(102, 102, 102, 0.1)",
          borderRightWidth: 1,
          borderRightColor: "rgba(102, 102, 102, 0.1)",

          background: "#FFFFFF",

          paddingTop: 30,
          paddingLeft: 40,
          paddingRight: 40,
          backgroundColor: "white",
        },
        iosPhone: { paddingVertical: 3 },
        iosTablet: {
          borderTopRightRadius: 10,
          borderTopLeftRadius: 10,

          borderLeftWidth: 1,
          borderLeftColor: "rgba(102, 102, 102, 0.1)",
          borderTopWidth: 1,
          borderTopColor: "rgba(102, 102, 102, 0.1)",
          borderRightWidth: 1,
          borderRightColor: "rgba(102, 102, 102, 0.1)",

          background: "#FFFFFF",

          paddingTop: 30,
          paddingLeft: 40,
          paddingRight: 40,
          backgroundColor: "white",
        },
        androidPhone: { paddingVertical: 3 },
        androidTablet: {
          borderTopRightRadius: 10,
          borderTopLeftRadius: 10,

          borderLeftWidth: 1,
          borderLeftColor: "rgba(102, 102, 102, 0.1)",
          borderTopWidth: 1,
          borderTopColor: "rgba(102, 102, 102, 0.1)",
          borderRightWidth: 1,
          borderRightColor: "rgba(102, 102, 102, 0.1)",

          background: "#FFFFFF",

          paddingTop: 30,
          paddingLeft: 40,
          paddingRight: 40,
          backgroundColor: "white",
        },
      }),
    },
    nextButton: {
      flex: 1,
      justifyContent: "flex-end",
      marginBottom: theme.spacing.medium,
      marginHorizontal: theme.spacing.medium,
    },
    check: {
      height: 170,
      resizeMode: "stretch",
      marginBottom: theme.spacing.small,
    },
  });
};

export default PaymentFlowPaymentMethodMobileCheckPaymentProcessing;
